'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = require('immutable');

var _LoopRecord = require('./LoopRecord');

var _LoopRecord2 = _interopRequireDefault(_LoopRecord);

var _store = require('../../store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MS_TO_S = 1000;
var NOT_SET = 'NOT_SET';

var PlayerRecord = function (_Record) {
  _inherits(PlayerRecord, _Record);

  function PlayerRecord() {
    _classCallCheck(this, PlayerRecord);

    var _this = _possibleConstructorReturn(this, (PlayerRecord.__proto__ || Object.getPrototypeOf(PlayerRecord)).call(this));

    _this._qualities = [];
    return _this;
  }

  _createClass(PlayerRecord, [{
    key: 'currentTimeMs',
    get: function get() {
      var player = _store2.default.getPlayerInstance(this.playerId);
      if (!player) {
        return 0;
      }
      return player.currentTime * 1000;
    }
  }, {
    key: 'durationMs',
    get: function get() {
      var player = _store2.default.getPlayerInstance(this.playerId);
      if (!player) {
        var playable = this.playables.get(this.playingIndex);
        if (playable) {
          playable.durationMs = playable.durationMs || playable.duration * MS_TO_S;
          return playable.durationMs || playable.endTimeMs - playable.startTimeMs;
        }
        return 0;
      }
      return player.duration * 1000;
    }
  }, {
    key: 'expectedDurationMs',
    get: function get() {
      var player = _store2.default.getPlayerInstance(this.playerId);
      if (!player) {
        return this.durationMs;
      }
      return player.expectedDuration * 1000;
    }
  }]);

  return PlayerRecord;
}((0, _immutable.Record)({
  adBegan: false,
  adEnded: false,
  audioDisabled: false,
  autoplay: true,
  autoAdvance: true,
  canPlay: false,
  aspectRatio: 16 / 9,
  currentQuality: null,
  qualities: (0, _immutable.List)(),
  contextMenuOpen: false,
  fullscreen: false,
  focused: true,
  seeking: false,
  loop: new _LoopRecord2.default(),
  muted: false,
  paused: true,
  durationMs: 0,
  expectedDurationMs: 0,
  live: false,
  playables: (0, _immutable.List)([]),
  playbackRate: 1,
  playingIndex: 0,
  playerId: NOT_SET,
  queueEnded: false,
  qualityChangeLoading: true,
  selectedStreamId: null,
  switchingStreams: -1,
  viNode: '',
  volume: 1,
  error: null,
  width: 0,
  height: 0
}));

exports.default = PlayerRecord;
module.exports = exports['default'];